import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
} from "@chakra-ui/react";
import AssessmentDataService from "../../services/Assessment";
export const DeletePaymentLinkModal = ({
  isOpen,
  onClose,
  id,
  func,
  price,
}: any) => {
  const token = localStorage.getItem("logged_in_user_token");
  const deletePaymentLink = async () => {
    try {
      const res = await AssessmentDataService.deletePayments(token, id);
      // console.log(res);
      func();
      onClose()
    } catch (error) {
      console.log(error);
      onClose()
    }
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Payment Link</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          {`Are you sure you want to delete payment link of ₹ ${price} ?`}
        </ModalBody>

        <ModalFooter>
          <Button
            bgColor="#327171"
            color={"white"}
            mr={3}
            onClick={deletePaymentLink}
          >
            Delete
          </Button>
          <Button bgColor="red" color={"white"} mr={3} onClick={onClose}>
            No
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
